__turbopack_context__.v({
  "icon": "UserIcon-module__kN7NnG__icon",
});
